<script lang="ts" setup>
defineEmits(['click'])

defineProps({
  items: {
    type: Array,
    required: true,
  },

  labelProperty: {
    type: String,
    default: null,
  },
})
</script>

<template>
  <div class="tile-selector">
    <div
      v-for="(item, i) in items"
      :key="`item-${i}`"
      class="tile-selector-item"
      @click="$emit('click', item)"
    >
      {{ labelProperty ? item[labelProperty] : item }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.tile-selector {
  display: flex;
  flex-flow: row wrap;
  gap: 1em;
  padding: 0.25em;

  .tile-selector-item {
    background-color: $color-background;
    padding: 1em;
    box-shadow: 0 0 0.25em $color-border;
    border: none;
    border-radius: 0.5em;
    cursor: pointer;
    transition: transform $default-transition;

    &:hover {
      transform: scale(1.0125);
    }
  }
}
</style>
